export default "__VITE_ASSET__o8mRY2iL__"